import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    rows: [],
  },
  reducers: {
    replaceData(state, action) {
      state.rows = action.payload;
    },
  },
});

export const userActions = userSlice.actions;
export default userSlice;